// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".register-form[data-v-324e5e2e]{max-width:600px;width:600px}.option-text[data-v-324e5e2e]{margin-left:8px}.non-active-font[data-v-324e5e2e]{color:#ccc}.non-active[data-v-324e5e2e]{cursor:not-allowed;color:#ccc;background-color:#e4e4e4!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
